const redirectURI = window.location.origin;

export const appleAuthOptions = {
  scope: 'email name',
  redirectURI,
  state: '',
  nonce: 'nonce',
  usePopup: true
};